import React, { useState, } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { arrayOfFeaturedItems } from '../../../constants/mainFunctions';
import style from './currentCoinComponent.module.css'


const CurrentCoinFeatureProducts = (props) => {

    const router = useRouter()
    const { id } = router.query
    const [myImgId, setMyImgId] = useState(null)

    const myLoader = ({ src, width, quality }) => {
        return `${src}?w=${width}&q=${quality || 75}`
    }
    const { featured } = arrayOfFeaturedItems(props?.data, id)

    return (<>{featured?.length > 0 ? <React.Fragment>
        <article className='sectionOrArticleB'>
            <h1>Similar Product You May Like</h1>
            <Container>
                <Row className='justify-content-center  pt-1 pt-md-3 pt-lg-4'>
                    {featured?.map((e, i) => <Col xs={12} sm={6} md={6} lg={4} xl={3} xxl={3} key={i} className='mb-3' >
                        <Card style={{ maxWidth: '18rem', margin: '.3rem', height: '100%' }} className='h-100 border-0'>
                            <Link href={`/${props?.coinLink}/${e?.docId}`} passHref legacyBehavior>
                                <a onClick={async () => {
                                    await router.push(`/${props?.coinLink}/${e?.docId}`)
                                    await window.location.reload()
                                }}>
                                    <div className={style.container} >
                                        <div className={style.text}>
                                            {myImgId == e?.docId ? <Image
                                                src={`${e?.image2}`}
                                                loader={myLoader}
                                                alt={e?.title}
                                                fill
                                                priority={true}
                                                sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                quality={70}
                                                className='cardImage'
                                                onMouseEnter={() => {
                                                    setMyImgId(e?.docId)
                                                }}
                                                onMouseLeave={() => setMyImgId(null)}
                                            /> :
                                                <Image
                                                    src={`${e?.image1}`}
                                                    loader={myLoader}
                                                    alt={e?.title}
                                                    fill
                                                    priority={true}
                                                    sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                    quality={70}
                                                    className='cardImage'
                                                    onMouseEnter={() => {
                                                        setMyImgId(e.docId)
                                                    }}
                                                    onMouseLeave={() => setMyImgId(null)}
                                                />}
                                        </div>
                                    </div>
                                    <Card.Body >
                                        <p className={style.cardsDescription}>{e?.title}</p>
                                        <p className={`${style.cardsPrice} bg-warning`}>US <span className={style.priceCard}>
                                            {Number(e?.price).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}
                                        </span></p>
                                    </Card.Body>
                                </a>
                            </Link>
                        </Card>
                    </Col>)}
                </Row>
            </Container>
        </article>
    </React.Fragment> :
        null
    }</>)
}
export default CurrentCoinFeatureProducts